const BRAND_CODES = {
  anpac: 'anpac',
  comerica: 'comerica',
  aolidg: 'aolidg',
  creditnotify: 'creditnotify',
  homeTitleGuardian: 'hometitle',
  idguard: 'idguard',
  barclays: 'barclays',
  myPrivacyAssist: 'boapa',
  bofwest: 'bofwest',
  discover: 'discover',
  enguard: 'enguard',
  pcprotect: 'pcprotect',
  scanguard: 'scanguard',
  totalAv: 'totalav',
  privacyShield: 'privacy',
  privacyMedicalShield: 'psms',
  missGroupSafe: 'mgsafe',
  domeneShop: 'dshop',
  domainkeskusSafe: 'dsafe',
  partyhat: 'partyhat',
  protectIV: 'protectiv',
  phSafe: 'phsafe',
  identityDefense: 'iddefense',
  financialShield: 'afs2',
  medicalShield: 'mshield',
  minorDefense: 'dminor',
  creditmon: 'creditmon',
  ultraAv: 'ultraav',
  pradvantage: 'pradvantage',
} as const;

export default BRAND_CODES;
